export const formInitialValues = () => {
  return {
    name: "",
    category: "other",
  };
};
